(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-banners"] && !Shopify.designMode) return;
  try {
    
// Add your custom JavaScript for the section here

  } catch(e) { console.error(e); }
})();
})();
